import React from 'react';

import { token } from '@atlaskit/tokens';
import { Box } from '@atlaskit/primitives/compiled/box';
import { cssMap } from '@atlaskit/css';

import { useShowUploadErrors } from '../../../hooks/useShowUploadErrors.tsx';
import type { Doc } from '../../../hooks/useUploadReducer.ts';

const styles = cssMap({
	message: {
		font: token('font.body.small'),
	},
});

type ErrorMessageProps = {
	doc: Doc;
};

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ doc }) => {
	const errMessage = useShowUploadErrors(doc);

	return (
		<Box xcss={styles.message} testId="error-message-component">
			{errMessage}
		</Box>
	);
};
